import { cn } from "@newxsystems/shared";
import { WohaAction } from "../WohaAction/WohaAction";
import { WohaRichText } from "../WohaRichText/WohaRichText";
import type { IWohaCommonContentProps } from "./WohaCommonContent.props";
export const WohaCommonContent = ({
  alignment,
  buttons,
  className,
  description,
  eyebrow,
  heading,
  headingAs = "h2",
  headingClassName,
  tone = "light",
}: IWohaCommonContentProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;
  const Heading = headingAs;
  const centered = alignment === "center";
  return (
    <div
      className={cn(
        "flex max-w-[48rem] flex-col gap-4",
        centered && "mx-auto items-center text-center",
        className,
      )}
    >
      {eyebrow ? (
        <p
          className={cn(
            "w-fit rounded-full px-3 py-1.5 text-sm font-medium",
            tone === "dark" ? "bg-white/10 text-white" : "bg-soft-blue text-deep-sapphire",
          )}
        >
          {eyebrow}
        </p>
      ) : null}
      {heading ? (
        <Heading
          className={cn(
            "font-satoshi text-4xl font-medium leading-[1.04] tracking-[-0.025em] text-balance md:text-5xl",
            tone === "dark" ? "text-white" : "text-charcoal",
            headingClassName,
          )}
        >
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <WohaRichText
          className={cn(
            "max-w-[65ch] text-lg leading-8 text-pretty",
            tone === "dark" ? "text-white/75" : "text-steel",
          )}
          content={description}
        />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-2", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <WohaAction
              action={button}
              className={
                tone === "dark"
                  ? "border-white bg-white text-charcoal hover:bg-paper-mist"
                  : undefined
              }
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};
WohaCommonContent.displayName = "Content::WohaCommonContent";
